import { render, staticRenderFns } from "./ClientCreationModal.vue?vue&type=template&id=122b046c&scoped=true&"
import script from "./ClientCreationModal.vue?vue&type=script&lang=js&"
export * from "./ClientCreationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122b046c",
  null
  
)

export default component.exports